<template>
<!--S 新闻详情   -->
<section class="wraper">
  <div class="container">
    <h3 class="h3">{{aboutus.name}}</h3>
    <hr>
    <p v-html="aboutus.content">
    </p>
  </div>
</section>
</template>
<script>
import { post, get } from "@/axios/index";
export default {
  data() {
    return {
    aboutus:{},
    id:''
    };
  },
  methods: {

  },
    mounted() {
    //获取新闻详情
    get("/stknewscenterinfo/getbyid", {id:this.$route.query.id}).then(
      response => {
        this.aboutus = response.data.result;
      },
      err => {
        console.log(err);
        this.$message({
          type: "error",
          message: "error"
        });
      }
    );
  }
}
</script>
<style lang="less" scoped>
.wraper {
  width: 100%;
  height: 100%;
  .container {
    width: 1060px;
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
        margin-top: 4%;
    margin-bottom: 4%;
    h3 {
      font-size: 18px;
      font-weight: bold;
      line-height: 30px;
      color: #2ba0fe;
    }
    p {
      line-height: 30px;
      text-align: justify;
      text-indent: 32px;
    }
  }
}
.h3{
  text-align: center;
  // position: relative;
  // left: 30%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/newsCenter/details.vue